import { XIcon } from '@phosphor-icons/react';

import styles from './image-lightbox.module.scss';

export type ImageLightboxProps = {
  /** Image URL to display. */
  src: string;
  /** Accessible name for the dialog; also drives the dismiss controls' labels. */
  label?: string;
  onClose: () => void;
};

/** Centred, bounded image preview over a dim scrim (Figma 343:331852). Dismissed by the close
 *  button or the backdrop. The consumer owns mounting — render it conditionally. */
export function ImageLightbox({ src, label = 'Image preview', onClose }: ImageLightboxProps) {
  const closeLabel = `Close ${label.toLowerCase()}`;

  return (
    <div className={styles.mask}>
      <button type="button" className={styles.backdrop} aria-label={closeLabel} onClick={onClose} />
      <div className={styles.card} role="dialog" aria-modal="true" aria-label={label}>
        <button type="button" className={styles.close} aria-label={closeLabel} onClick={onClose}>
          <XIcon size={14} aria-hidden />
        </button>
        <img className={styles.img} src={src} alt="" />
      </div>
    </div>
  );
}
